import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

import { useUserContext } from "../UserContext";
import { getPrimaryRole } from "../auth/access";
import { isSuperiorInstructorType } from "../constants/instructors";
import { useResolvedInstructor } from "../hooks/useResolvedInstructor";
import { canUseCalendarV2, newCalendarPathFor, oldCalendarPathFor } from "../calendarV2/calendarV2Access";

const CalendarV2Page = lazy(() => import("../calendarV2/CalendarV2Page"));

function Waiting({ text, spinner = true }) {
   return (
      <main className="main" style={{ padding: 0 }}>
         <div className="dayview__loading" role="status" aria-live="polite">
            {spinner ? <div className="dayview__spinner" /> : null}
            <span>{text}</span>
         </div>
      </main>
   );
}

/**
 * Calendarul nou (/admin|manager|instructor/calendar-nou și /instructor/calendar-nou/practice).
 * Cine nu îl are încă — înapoi la cel de acum. Instructorul: întâi fișa lui (ca „Orarul meu” de acum);
 * „Orar practice” (toți instructorii) — doar SUPERIOR, ceilalți ajung la calendarul lor.
 */
export default function CalendarV2Route({ practice = false }) {
   const { user } = useUserContext() || {};
   const { instructor, resolved } = useResolvedInstructor();
   if (user && !canUseCalendarV2(user)) return <Navigate to={oldCalendarPathFor(user, { practice })} replace />;

   const isInstructor = getPrimaryRole(user) === "INSTRUCTOR";
   if (isInstructor && !resolved) return <Waiting text="Se încarcă profilul instructorului…" />;
   if (isInstructor && !instructor?.id) return <Waiting text="Profilul de instructor nu a fost găsit." spinner={false} />;
   if (practice && !isSuperiorInstructorType(instructor?.instructorType)) {
      return <Navigate to={newCalendarPathFor(user)} replace />;
   }

   return (
      <main className="main" style={{ padding: 0 }}>
         <Suspense fallback={<Waiting text="Se încarcă calendarul nou…" />}>
            <CalendarV2Page practice={practice} instructor={isInstructor ? instructor : null} />
         </Suspense>
      </main>
   );
}
